module.exports = __webpack_public_path__ + "img/bernhardt.8555c8f.jpg";